var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroovesMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 120,
    viewBox: "0 0 192 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1753 114.127L162.886 91.9648L160.67 96.3975L77.959 118.559L80.1753 114.127Z",
    fill: "#E3E5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.861 116.334L242.268 98.8081L240.052 103.241L174.645 120.767L176.861 116.334Z",
    fill: "#051371"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.666 91.1333L148.341 80.7715L143.333 90.7878L104.659 101.15L109.666 91.1333Z",
    fill: "#051371"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.718 61.2217L237.981 38.6436L232.524 49.5555L148.262 72.1337L153.718 61.2217Z",
    fill: "#EF0808"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.857 103.439L186.107 94.2612L184.504 97.467L150.254 106.645L151.857 103.439Z",
    fill: "#EF0808"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.23 63.8582L159.695 53.2837L158.638 55.3988L119.172 65.9733L120.23 63.8582Z",
    fill: "#C3C6E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroovesMobile);
export default __webpack_public_path__ + "static/media/grooves_mobile.85f711b4a05a3f49d11eeae7530b0cf3.svg";
export { ForwardRef as ReactComponent };